/** Status da revisão do cliente */
export interface ClienteRevisaoStatus {
    id: number;
    nome: string;
}

export const clienteRevisaoStatusPendente: ClienteRevisaoStatus = {id: 1, nome: 'Pendente'};
export const clienteRevisaoStatusConfirmada: ClienteRevisaoStatus = {id: 2, nome: 'Confirmada'};

export const clienteRevisaoStatus: ClienteRevisaoStatus[] = [
    clienteRevisaoStatusPendente,
    clienteRevisaoStatusConfirmada
];


/** Verifica se o status da revisão do cliente é Pendente */
export function isClienteRevisaoStatusPendente(revisaoStatus: number): boolean {
    return revisaoStatus === clienteRevisaoStatusPendente.id;
}

/** Verifica se o status da revisão do cliente é Confirmada */
export function isClienteRevisaoStatusConfirmada(revisaoStatus: number): boolean {
    return revisaoStatus === clienteRevisaoStatusConfirmada.id;
}
